import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  PDFViewer,
} from '@react-pdf/renderer';
// import backgroundImage from '../../assets/images/tc/blank.png';
import backgroundImage from '../../assets/blank.png';
import { formatDate, dateToWords } from '../../constants/DateFormatter';
import { Font } from '@react-pdf/renderer';

// const RobotoRegular = require('./fonts/Roboto-Regular.ttf');
// const RobotoBold  = require('./fonts/Roboto-Bold.ttf');

// Font.register({
//   family: 'Roboto',
//   fonts: [
//     { src: RobotoRegular },
//     { src: RobotoBold, fontWeight: 'bold' },
//   ],
// });

// Create styles
const styles = StyleSheet.create({
  text: {
    position: 'absolute',
    fontSize: 12,
    //fontFamily:"Roboto",
    fontWeight:"bold"
    // left: '0px',
    // right: '0px',
    // marginHorizontal: 'auto',
    //textAlign: "center",
    //justifyContent: 'center',
  },
  studentPhoto: { top: '15px', left: '500px', width: 60, height: 80, borderRadius: 5, position: 'absolute', },
  logoPhoto: { top: '15px', left: '30px', width: 50, height: 50, borderRadius: 5, position: 'absolute', },
});

// Create Document Component
const PdfView = ({ admission_Data, tc_Issue_Master_Data, schoolData }) => (
  <Document>
    <Page size='A4' style={styles.page}>

      <Image src={backgroundImage} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} fixed></Image>

      <Image src={"/assets/logos/" + schoolData.school_logo} style={styles.logoPhoto} />

      <Image src={{ uri: process.env.REACT_APP_API_BASE_URL + admission_Data?.admission?.stud_img_path, method: "GET", headers: { "Cache-Control": "no-cache" }, body: "" }} style={styles.studentPhoto} />

      <Text
        style={{
          top: '20px',
          marginHorizontal: 'auto',
          justifyContent: 'center',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          color: 'green',
          fontStyle: 'Italic',
          fontWeight: 'bold',
          fontSize: '20px',
          position: 'absolute',
        }}
      >
        {schoolData?.school_name}
      </Text>
      <Text
        style={{
          top: '40px',
          justifyContent: 'center',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          fontSize: '10px',
          position: 'absolute',
        }}
      >
        {schoolData?.school_type}
      </Text>
      {/* <Text
        style={{
          top: '50px',
          marginHorizontal: 'auto',
          justifyContent: 'center',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          fontSize: '10px',
          position: 'absolute',
        }}
      >
        {schoolData?.address}
      </Text> */}
      <Text
        style={{
          top: '50px',
          marginHorizontal: 'auto',
          justifyContent: 'center',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          fontSize: '10px',
          position: 'absolute',
        }}
      >
        {schoolData?.address}
      </Text>
      
      <Text
        style={{
          top: '85px',
          left: '70px',
          right: '0px',
          fontSize: '12px',
          position: 'absolute',
        }}
      >
        
        {schoolData?.school_code}
      </Text>
      <Text
        style={{
          top: '70px',
          marginHorizontal: 'auto',
          justifyContent: 'center',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          color: 'blue',
          fontSize: '15px',
          position: 'absolute',
        }}
      >
        
        {tc_Issue_Master_Data?.certificate_type} COPY
      </Text>

      {/* <Text style={{ top: '85px', left: '80px', ...styles.text }}>A56421</Text> */}

      <Text style={{ top: '142px', left: '150px', ...styles.text }}>
        {tc_Issue_Master_Data?.session_year}
      </Text>

      <Text style={{ top: '165px', left: '48px', ...styles.text }}>
        PEN ID : 
      </Text>
      <Text
  style={{
    top: 162,
    left: 140,
    width: 150, // fixed length of dotted line
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    borderStyle: 'dashed',
    ...styles.text
  }}
>
  {admission_Data?.admission?.pen_id || '\u00A0'}
</Text>

      <Text style={{ top: '137px', left: '450px', ...styles.text }}>
        {tc_Issue_Master_Data?.file_no_1}
      </Text>
      <Text style={{ top: '160px', left: '450px', ...styles.text }}>
        {admission_Data?.admission?.admit_no}
      </Text>
      <Text style={{ top: '185px', left: '150px', ...styles.text }}>
        {admission_Data?.admission?.stud_name}
      </Text>
      <Text style={{ top: '227px', left: '150px', ...styles.text }}>
        {formatDate(admission_Data?.admission?.d_o_b)}
      </Text>
      <Text style={{ top: '227px', left: '300px', ...styles.text }}>
        {dateToWords(admission_Data?.admission?.d_o_b)}
      </Text>
      <Text style={{ top: '250px', left: '150px', ...styles.text }}>
        {admission_Data?.admission?.stud_name}
      </Text>
      <Text style={{ top: '275px', left: '150px', ...styles.text }}>
        {admission_Data?.admission?.f_name}
      </Text>
      <Text style={{ top: '300px', left: '150px', ...styles.text }}>
        {admission_Data?.admission?.m_name}
      </Text>
      <Text style={{ top: '323px', left: '250px', ...styles.text }}>
        {formatDate(admission_Data?.admission?.last_attended_date)}
      </Text>
      <Text style={{ top: '353px', left: '100px', ...styles.text }}>
        {tc_Issue_Master_Data?.curr_class}
      </Text>
      <Text style={{ top: '353px', left: '250px', ...styles.text }}>
        {tc_Issue_Master_Data?.sys_remark}
      </Text>
      <Text style={{ top: '375px', left: '285px', ...styles.text }}>

      </Text>
      <Text style={{ top: '375px', left: '405px', ...styles.text }}>

      </Text>
      <Text style={{ top: '420px', left: '320px', ...styles.text }}>
        {tc_Issue_Master_Data?.result_detail}
      </Text>
      <Text
        style={{
          top: '450px',
          left: '270px',
          color: 'green',
          fontStyle: 'Italic',
          fontWeight: 'bold',
          fontSize: '20px',
          position: 'absolute',
        }}
      >
        {schoolData?.school_name}
      </Text>
      <Text
        style={{
          top: '565px',
          left: '45px',
          width: 70,
          fontSize: 9,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {schoolData?.school_name}
      </Text>
      <Text
        style={{
          top: '590px',
          left: '45px',
          width: 80,
          fontSize: 9,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {schoolData?.address}
      </Text>
      {/* <Text
        style={{
          top: '585px',
          left: '40px',
          width: 90,
          fontSize: 8,
          flexShrink: 1,
          position: 'absolute',
        }}
      >

      </Text> */}
      <Text
        style={{
          top: '575px',
          left: '130px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {formatDate(admission_Data?.admission?.adm_date)}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '200px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {formatDate(tc_Issue_Master_Data?.withdraw_date)}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '270px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {tc_Issue_Master_Data?.from_year}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '314px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {tc_Issue_Master_Data?.to_year}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '370px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {tc_Issue_Master_Data?.possible_attend_days}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '440px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {tc_Issue_Master_Data?.attendance_days}
      </Text>
      <Text
        style={{
          top: '575px',
          left: '510px',
          width: 100,
          fontSize: 10,
          flexShrink: 1,
          position: 'absolute',
        }}
      >
        {tc_Issue_Master_Data?.leave_taken_days}
      </Text>
      <Text style={{ top: '633px', left: '130px', ...styles.text }}>
        {formatDate(tc_Issue_Master_Data?.issue_date)}
      </Text>
      <Text style={{ top: '653px', left: '120px', ...styles.text }}>
        {schoolData?.prepared_by}
      </Text>
      <Text style={{ top: '650px', left: '440px', ...styles.text }}>
        {schoolData?.checked_by}
      </Text>
      <Text style={{ top: '678px', left: '120px', ...styles.text }}>
        {schoolData?.head_of_institution}
      </Text>
    </Page>
  </Document>
);
export default PdfView;
